import React from "react";
import ReleaseNotes from "../../features/release-notes/ReleaseNotes";

const ReleaseNotesPage: React.FC = () => {
  return <ReleaseNotes />;
};

export default ReleaseNotesPage;
